/**
 * Launch an application on LG WebOS platform
 * @param {Object} app The app object containing app_id and other properties
 * @returns {Promise<boolean>} Success status of the launch
 */
export const launchApp = (app) => {
  return new Promise((resolve) => {
    if (!window.webOS) {
      console.error("WebOS not available");
      resolve(false);
      return;
    }

    try {
      const appInfo = {
        id: app.app_id,
        params: {
          // Add any additional parameters needed for the app
        },
      };

      window.webOS.service.request("luna://com.webos.applicationManager", {
        method: "launch",
        parameters: appInfo,
        onSuccess: () => {
          resolve(true);
        },
        onFailure: (inError) => {
          console.error("Failed to launch LG app:", inError);
          resolve(false);
        },
      });
    } catch (error) {
      console.error("Error launching LG app:", error);
      resolve(false);
    }
  });
};
